import BaseRequest from './BaseRequest';

const schema = 'favorite';

export default class FavoriteRequest extends BaseRequest {
  fetchAffiliate(params) {
    const url = `${schema}/affiliate`;
    return this.get(url, params);
  }

  createAffiliate(data) {
    const url = `${schema}/affiliate`;
    return this.post(url, data);
  }

  fetchAffiliateDetail(params) {
    const url = `${schema}/affiliate/detail`;
    return this.get(url, params);
  }

  deleteAffiliate(params) {
    const url = `${schema}/affiliate/${params.pubkey}`;
    return this.del(url);
  }
}
